export const calcLampsPositions = (lampsCount: number): number[] => {
    const lampsPositions = [];
    if (lampsCount < 1) {
        lampsPositions.push(0);
    } else {
        const startPosition = -lampsCount / 2 + 0.5;
        for (let i = 0; i < lampsCount; i++) {
            lampsPositions.push(startPosition + i);
        }
    }
    return lampsPositions;
};
